// from http://chalmershouse.co.uk/2011/08/13/javascript-is_array-isarray-typeof-array-check/;

function type(obj) {
    if (obj === null || typeof obj === 'undefined') {
        return String(obj);
    }
    return Object.prototype.toString.call(obj)
        .replace(/\[object ([a-zA-Z]+)\]/, '$1').toLowerCase();
};

function isArray(obj) {
    // do an instanceof check first
    if (obj instanceof Array) {
        return true;
    }
    // then check for obvious falses
    if (typeof obj !== 'object') {
        return false;
    }
    if (type(obj) === 'array') {
        return true;
    }
    return false;
};

// from http://www.webdeveloper.com/forum/showthread.php?193474-Determining-if-a-javascript-object-is-empty
function isEmpty(o) {
    for (var p in o) {
        if (o[p] != o.constructor.prototype[p])
            return false;
    }
    return true;
}



